<template lang="">
    <div>
        <h1 class="h1 font-weight-bold text-dark">{{ name }}</h1>
        <front-product-list :category-id="categoryId"></front-product-list>
        <front-category-shower v-if="deep" :category-id="child.id" v-for="(child, index) in children" :key="index">
        </front-category-shower>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        props: {
            deep: {
                default: false
            },
            categoryId: {
                default: 0
            }
        },
        data() {
            return {
                name: '',
                children: [],
                products: []
            }
        },
        mounted() {
            this.initCategories();
        },
        methods: {
            initCategories() {
                axios.get(`${base_url}/api/category/${this.categoryId}`)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        this.name = response_data.name;
                        this.children = response_data.children;
                    })
                    .catch((...response_error) => { });
            }
        }
    }
</script>